import { useQuery, useQueryClient } from '@tanstack/react-query'

import useAppStore from '@/store/useAppStore'

import httpClient from '@/lib/httpClient'

export default function useGetCellTransactions({
  entityType,
  entityId,
  start,
  end,
  enabled = true,
}: {
  entityType: 'vaults' | 'transaction_categories'
  entityId: number
  start: string | Date
  end: string | Date
  enabled?: boolean
}) {
  const queryClient = useQueryClient()
  const { setCellTransactionsLoaded } = useAppStore()

  const fetchData = async () => {
    setCellTransactionsLoaded(false)
    const response = await httpClient.get(
      `/team/cash-flow/transactions/index`,
      {
        params: {
          entity_type: entityType,
          entity_id: entityId,
          start,
          end,
        },
      },
    )
    setCellTransactionsLoaded(true)
    return response.data.data
  }

  return useQuery({
    queryKey: ['transactions', 'cell', { entityType, entityId, start, end }],
    queryFn: fetchData,
    enabled,
  })
}
